<template>
    <div class="com-steps">
        <div class="com-steps-wrapper">
            <div class="com-steps__items">
                <div :class="activeCls(0)">
                    <div class="com-steps__item-title">域名解析</div>
                    <div class="com-steps__item-line">
                        <span></span>
                    </div>
                    <div class="com-steps__item-subtitle">第一步</div>
                </div>
                <div :class="activeCls(1)">
                    <div class="com-steps__item-title">填写网站信息</div>
                    <div class="com-steps__item-line">
                        <span></span>
                    </div>
                    <div class="com-steps__item-subtitle">第二步</div>
                </div>
                <div :class="activeCls(2)">
                    <div class="com-steps__item-title">设置发件邮箱</div>
                    <div class="com-steps__item-line">
                        <span></span>
                    </div>
                    <div class="com-steps__item-subtitle">第三步</div>
                </div>
                <div :class="activeCls(3)">
                    <div class="com-steps__item-title">填写仓库地址</div>
                    <div class="com-steps__item-line">
                        <span></span>
                    </div>
                    <div class="com-steps__item-subtitle">第四步</div>
                </div>
                <div :class="activeCls(4)">
                    <div class="com-steps__item-title">提交信息</div>
                    <div class="com-steps__item-line">
                        <span></span>
                    </div>
                    <div class="com-steps__item-subtitle">完成</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'step-header',
    props: {
        activeKey: String
    },
    methods: {
        activeCls: function(key) {
            return {
                'com-steps__item': true,
                'is-active': Number(this.activeKey) >= key
            }
        }
    }
}
</script>

<style lang="less" scoped>
    .com-steps {
        &__items {
            display: flex;
        }
        &__item {
            flex: 1;
            text-align: center;
            &-title {
                padding: .3rem 0;
                font-size: .28rem;
                font-weight: bold;
            }
            &:first-child {
                .com-steps__item-line {
                    border-radius: 5px 0 0 5px;
                }
            }
            &:last-child {
                .com-steps__item-line {
                    border-radius: 0 5px 5px 0;
                }
            }
            &-line {
                height: .08rem;
                background-color: #ccc;
                span {
                    display: inline-block;
                    position: relative;
                    width: .25rem;
                    height: .25rem;
                    top: -.08rem;
                    border-radius: 50%;
                    background-color: #ccc;
                }
            }
            &-subtitle {
                padding: .2rem 0;
            }
            &.is-active {
                .com-steps__item {
                    &-title, &-subtitle  {
                        color: #007aff;
                    }
                    &-line, &-line span {
                        background-color: #007aff;
                    }
                }
            }
        }
    }
</style>


